var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBehanceSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.25 9.16667C7.17047 9.16667 7.91667 8.4205 7.91667 7.5C7.91667 6.57952 7.17047 5.83333 6.25 5.83333H2.5V9.16667H6.25ZM7.08333 10.8333H2.5V14.1667H7.08333C8.00381 14.1667 8.75 13.4205 8.75 12.5C8.75 11.5795 8.00381 10.8333 7.08333 10.8333ZM8.80267 9.64375C9.76992 10.2272 10.4167 11.2881 10.4167 12.5C10.4167 14.3409 8.92425 15.8333 7.08333 15.8333H0.833332V4.16667H6.25C8.09095 4.16667 9.58333 5.65905 9.58333 7.5C9.58333 8.31637 9.28983 9.06417 8.80267 9.64375ZM12.9167 5H17.5V6.25H12.9167V5ZM19.1667 12.0833H12.9167V12.2917C12.9167 13.5573 13.9427 14.5833 15.2083 14.5833C16.0989 14.5833 16.8708 14.0753 17.2501 13.3333H19.0282C18.5709 15.0141 17.0339 16.25 15.2083 16.25C13.0222 16.25 11.25 14.4778 11.25 12.2917V11.0417C11.25 8.8555 13.0222 7.08333 15.2083 7.08333C17.3945 7.08333 19.1667 8.8555 19.1667 11.0417V12.0833ZM17.4137 10.4167C17.1417 9.45475 16.2573 8.75 15.2083 8.75C14.1593 8.75 13.275 9.45475 13.0029 10.4167H17.4137Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehanceSvg);
export default __webpack_public_path__ + "static/media/behance-svg.6aba05004b65f960bec0fd4b862e2b3a.svg";
export { ForwardRef as ReactComponent };